module.exports = __webpack_public_path__ + "assets/images/closec979d908c2b4f4e83cc9695dc8c84469.svg";